import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Space, Typography } from 'antd';

import { Benefit, BenefitSubscription } from '../../types/customer';

const { Text } = Typography;

type SelectedSubscription = {
  benefit: Benefit;
  subscription: BenefitSubscription;
};

type BenefitStatusModalProps = {
  selectedSubscription: SelectedSubscription | null;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
};

export const BenefitStatusModal: React.FC<BenefitStatusModalProps> = ({
  selectedSubscription,
  isLoading,
  onCancel,
  onConfirm,
}) => {
  const isReactivation =
    selectedSubscription?.subscription.isActiveBenefit === false;
  const action = isReactivation ? 'reativar' : 'desativar';

  return (
    <Modal
      open={!!selectedSubscription}
      title={
        <Space>
          <ExclamationCircleOutlined style={{ color: '#FAAD14' }} />
          <Text strong>Confirmar alteração</Text>
        </Space>
      }
      centered
      width={650}
      okText='Sim'
      cancelText='Não'
      confirmLoading={isLoading}
      okButtonProps={{ disabled: isLoading }}
      cancelButtonProps={{ disabled: isLoading }}
      closable={!isLoading}
      maskClosable={!isLoading}
      keyboard={!isLoading}
      onCancel={() => {
        if (!isLoading) onCancel();
      }}
      onOk={onConfirm}
    >
      <Space direction='vertical' size='middle'>
        <Text>
          Deseja realmente {action} o benefício{' '}
          {selectedSubscription?.benefit.name} para o usuário?
        </Text>
        <Text type='secondary'>
          O status do benefício pode demorar um pouco para ser atualizado. Já a
          informação de “Optante?” é atualizada em tempo real.
        </Text>
      </Space>
    </Modal>
  );
};
